<template>
  <!-- Wrap everything in a single parent element -->
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }"
        :mobile-breakpoint="0"
        class="elevation-12 v-text-field--outlined"
        dense
    >
      <template v-slot:top>
        <v-row class="d-flex align-center" justify="space-between" style="padding: 20px">
          <v-col cols="12" md="3">
            <v-select
                v-model="filters.isActive"
                :items="isActiveFilterOptions"
                label="Активный"
                style="height: 40px"
                solo-inverted
                dense
                @change="updateItems"
            />
          </v-col>
          <v-col cols="12" md="4" class="text-end">
            <v-btn
                x-large
                color="warning"
                class="me-2"
                style="height: 40px"
                small
                outlined
                @click="openModal"
            >
              Добавить
            </v-btn>
            <v-btn
                x-large
                color="primary"
                class="me-2"
                style="height: 40px"
                dark
                outlined
                small
                @click="updateItems"
            >
              Обновить
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.ClientType`]="{ item }">
        <span>{{ Mapper.mapClient(item.ClientType)._name || 'Неизвестно' }}</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center">
          <v-btn
              small
              :color="item.IsActive ? 'green' : 'error'"
              :style="{ color: 'white' }"
              @click="toggleIsActive(item)"
          >
            <v-icon>
              {{ item.IsActive ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}
            </v-icon>
          </v-btn>

          <v-btn
              small
              style="margin-left: 8px"
              color="error"
              @click="deleteItem(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

    </v-data-table>

    <v-dialog v-model="modalVisible" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Задача пересылки почты</span>
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="saveModal">
            <div class="d-flex align-center align-baseline justify-center">
              <v-text-field
                  label="Введите UID или тему письма"
                  v-model="searchQuery"
                  dense
                  clearable
                  outlined
              />
              <v-btn
                  color="primary"
                  :disabled="!searchQuery"
                  @click="fetchMail"
              >
                Поиск
              </v-btn>
            </div>
            <v-select
                label="Письмо"
                v-model="formData.mail"
                item-value="id"
                item-text="uid"
                required
                dense
                clearable
                :items="filteredMails"
                :loading="mailsLoading"
            />

<!--            <v-select-->
<!--                label="Выберите клиента"-->
<!--                v-model="formData.clientType"-->
<!--                :items="clients()"-->
<!--                item-value="value"-->
<!--                item-text="text"-->
<!--                required-->
<!--            />-->

<!--            <v-select-->
<!--                label="Регион"-->
<!--                v-model="formData.regionId"-->
<!--                :items="this.$store.getters.appRegions"-->
<!--                item-value="id"-->
<!--                item-text="name"-->
<!--                required-->
<!--            />-->
<!--            <v-select-->
<!--                label="Область"-->
<!--                v-model="formData.areaId"-->
<!--                :items="this.$store.getters.appAreas.filter(i => i.region.id === this.formData.regionId)"-->
<!--                item-value="id"-->
<!--                item-text="name"-->
<!--                required-->
<!--            />-->
<!--            <v-text-field label="Адрес" v-model="formData.address" required />-->
<!--            <v-text-field label="Получатель" v-model="formData.receiver" required />-->
            <v-select
                label="Регион пересылки"
                v-model="formData.forwardedRegionId"
                :items="this.$store.getters.appRegions"
                item-value="id"
                item-text="name"
                required
            />
            <v-select
                label="Область пересылки"
                v-model="formData.forwardedAreaId"
                :items="this.$store.getters.appAreas.filter(i => i.region.id === this.formData.forwardedRegionId)"
                item-value="id"
                item-text="name"
                required
            />
            <v-text-field label="Адрес пересылки" v-model="formData.forwardedAddress" />
            <v-text-field label="Пост код пересылки" v-model="formData.forwardedPostCode" maxlength="6"/>
            <div class="d-flex justify-end">
              <v-btn variant="tonal" @click="closeModal">Отмена</v-btn>
              <v-btn variant="tonal" style="color: white; margin-left: 10px" color="green" type="submit" :disabled="!isFormValid()">Сохранить</v-btn>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "underscore";
import { LAYOUT_LOADING_START, LAYOUT_LOADING_STOP } from "@/store/modules/layout/actions";
import MailForwardService from "@/services/mail.forward.service";
import Mapper from "@/mappers";
import {clients} from "@/helpers/constants";
import MailService from "@/services/mail.service";
import Mappers from "@/mappers";

export default {
  components: {},
  name: "MailForwardDataTable",
  props: {
    forwardTasks: {
      type: Array,
      default: () => {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      filters: {
        isActive: true,
      },
      modalVisible: false,  // controls the visibility of the modal
      formData: {
        mail: null,
        clientType: "",
        regionId: null,
        areaId: null,
        address: "",
        receiver: "",
        forwardedRegionId: null,
        forwardedAreaId: null,
        forwardedPostCode: "",
        forwardedAddress: ""
      },
      searchQuery: '', // User input for mail search
      mailsLoading: false,
      filteredMails: []
    };
  },
  computed: {
    Mapper() {
      return Mapper;
    },
    items() {
      return _.map(this.forwardTasks, m => {
        return m;
      });
    },

    isActiveFilterOptions() {
      return [
        { text: 'Да', value: true },
        { text: 'Нет', value: false },
      ];
    },

    headers() {
      return [
        { text: '№', align: 'center', sortable: false, value: 'Id' },
        { text: 'Тип клиента', align: 'left', sortable: false, value: 'ClientType' },
        { text: 'Область', align: 'left', sortable: false, value: 'Region.Name' },
        { text: 'Регион', align: 'left', sortable: false, value: 'Area.Name' },
        { text: 'Адрес', align: 'left', sortable: false, value: 'Address' },
        { text: 'Получатель', align: 'left', sortable: false, value: 'Receiver' },
        { text: 'Адрес досыла', align: 'left', sortable: false, value: 'ForwardedAddress' },
        { text: 'Область досыла', align: 'left', sortable: false, value: 'ForwardedRegion.Name' },
        { text: 'Регион досыла', align: 'left', sortable: false, value: 'ForwardedArea.Name' },
        { text: 'Пост код', align: 'left', sortable: false, value: 'ForwardedPostCode' },
        { text: "Действия", align: "center", sortable: false, value: "actions" },
      ];
    },
  },
  methods: {
    async fetchMail() {
      if (!this.searchQuery) return; // Prevent empty search
      this.mailsLoading = true;
      try {
        const response = await MailService.get(this.searchQuery);
        const mail = Mappers.mapMail(response.data)
        console.log(mail)
        if (mail) {
          this.filteredMails = [mail];
          this.formData.mail = mail;
          this.formData.clientType = mail.client.id;
          this.formData.regionId = mail.region.id;
          this.formData.areaId = mail.area.id;
          this.formData.address = mail.address;
          this.formData.receiver = mail.receiver;
        } else {
          this.filteredMails = [];
          this.formData.mail = null;
        }
      } catch (error) {
        console.error('Error fetching mails:', error);
        this.filteredMails = [];
        this.formData.mail = null;
      } finally {
        this.mailsLoading = false;
      }
    },
    deleteItem(item){
      this.$store.dispatch(LAYOUT_LOADING_START);

      MailForwardService.delete(item.Id)
          .finally(() => {
            this.updateItems();
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
    isFormValid() {
      return this.formData.clientType !== null && this.formData.clientType !== '' &&
          this.formData.regionId !== null && this.formData.regionId !== '' &&
          this.formData.areaId !== null && this.formData.areaId !== '' &&
          this.formData.address !== null && this.formData.address !== '' &&
          this.formData.receiver !== null && this.formData.receiver !== '' &&
          this.formData.forwardedRegionId !== null && this.formData.forwardedRegionId !== '' &&
          this.formData.forwardedAreaId !== null && this.formData.forwardedAreaId !== '';
    },
    clients() {
      return clients
    },
    updateItems() {
      this.$emit("update", this.filters);
    },
    async toggleIsActive(item) {
      this.$store.dispatch(LAYOUT_LOADING_START);

      MailForwardService.put(item.Id, !item.IsActive)
          .finally(() => {
            this.updateItems();
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    },
    saveModal() {
      this.$store.dispatch(LAYOUT_LOADING_START);

      MailForwardService.post(
          {
            clientType: this.formData.clientType,
            regionId: this.formData.regionId,
            areaId: this.formData.areaId,
            address: this.formData.address,
            receiver: this.formData.receiver,
            forwardedRegionId: this.formData.forwardedRegionId,
            forwardedAreaId: this.formData.forwardedAreaId,
            forwardedPostCode: this.formData.forwardedPostCode,
            forwardedAddress: this.formData.forwardedAddress
          }
      )
          .catch(error => {
            // Handle error
            console.error('Error saving data:', error);
          })
          .finally(() => {
            this.updateItems();
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });

      this.closeModal(); // Close the modal after saving
    },
    // Method to open the modal
    openModal() {
      this.modalVisible = true;
    },
    // Method to close the modal
    closeModal() {
      this.modalVisible = false;
    },
    // Method to save the modal data (you can customize this)
  },
  created() {
    this.updateItems()
  },
  watch: {
    options: {
      handler() {
        this.updateItems();
      }
    },
  }
};
</script>

<style scoped>
.white--text a {
  color: #ffffff;
  text-decoration: none;
}
</style>
